"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentGuide = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/component/component-feature-list");
/** 컴포넌트 문서에서 특성 목록과 설명 산문을 함께 담는 가이드 영역. */
let ComponentGuide = class ComponentGuide extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.features = [];
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderFeatureList()}
      <slot></slot>
    `;
    }
    renderFeatureList() {
        if (!this.features.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-component-feature-list .features=${this.features}></mm-component-feature-list>
    `;
    }
};
ComponentGuide.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-8);
      padding: var(--space-section) 0 0;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentGuide.prototype, "features", void 0);
ComponentGuide = __decorate([
    (0, decorators_js_1.customElement)('mm-component-guide')
], ComponentGuide);
exports.ComponentGuide = ComponentGuide;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LWd1aWRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29tcG9uZW50LWd1aWRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsaUVBQThEO0FBRzlELDRDQUE0QztBQUVyQyxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFBdkM7O1FBUzJCLGFBQVEsR0FBMkIsRUFBRSxDQUFBO0lBZ0J2RSxDQUFDO0lBZEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsaUJBQWlCLEVBQUU7O0tBRTNCLENBQUE7SUFDSCxDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU07WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUV6QyxPQUFPLElBQUEsVUFBSSxFQUFBOzZDQUM4QixJQUFJLENBQUMsUUFBUTtLQUNyRCxDQUFBO0lBQ0gsQ0FBQzs7QUF2Qk0scUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7OztHQU9sQixDQUFBO0FBQytCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQztnREFBc0M7QUFUMUQsY0FBYztJQUQxQixJQUFBLDZCQUFhLEVBQUMsb0JBQW9CLENBQUM7R0FDdkIsY0FBYyxDQXlCMUI7QUF6Qlksd0NBQWMifQ==